export class MovementTypeModel {
  movementTypes?: [];

  constructor() {
    this.movementTypes = [];
  }
}
